import { BaseCrossBreedList, CrossBreedList } from '../data/crossDogBreedList';
import { PureDogBreedList } from '../data/pureDogBreedList';
import { CatBreedList } from '../data/catBreedList';

import type { BreedSchema } from '../types/breed';

const MixedDogBreedList: BreedSchema[] = [
  { id: '1', type: 'dog', breedName: 'Small mixed (up to 10kg)', isMixed: true },
  { id: '2', type: 'dog', breedName: 'Medium mixed (10 - 20kg)', isMixed: true },
  { id: '3', type: 'dog', breedName: 'Large mixed (over 20kg)', isMixed: true },
];

export const BasicBreeds: BreedSchema[] = [
  ...CatBreedList,
  ...PureDogBreedList,
  ...MixedDogBreedList,
  ...BaseCrossBreedList,
];

export const FullBreedsList: BreedSchema[] = [...BasicBreeds, ...CrossBreedList];

export const petBreedValueList = FullBreedsList.map((breed) => breed.breedName);
